__turbopack_context__.v({
  "container": "CookieConsent-module-scss-module__PLk-IW__container",
  "link": "CookieConsent-module-scss-module__PLk-IW__link",
  "visible": "CookieConsent-module-scss-module__PLk-IW__visible",
  "wrapper": "CookieConsent-module-scss-module__PLk-IW__wrapper",
});
